import { Component, Input } from '@angular/core';
import { ProductData } from '../../product.model';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent {

  @Input() productData!: ProductData;

  constructor(private translateService: TranslateService) { }

  get color() {
    return this.productData.color
      ? this.translateService.instant(`product.colors.${this.productData.color}`)
      : '-'
  }

  get tds() {
    return this.productData._links?.tds
  }

  get sds() {
    return this.productData._links?.sds
  }
}
